import { createContext } from 'react';

const datepickerContextDefaultValue = {
  startDate: null,
  endDate: null,
  range: false,
  focusedDate: null,
  isDateFocused: () => false,
  isDateSelected: () => false,
  isDateHovered: () => false,
  isDateBlocked: () => false,
  isFirstOrLastSelectedDate: () => false,
  onDateFocus: () => {},
  onDateHover: () => {},
  onDateSelect: () => {}
};

export default createContext(datepickerContextDefaultValue);
